module.exports = __webpack_public_path__ + "assets/img/ad6.db124897.svg";